export function scrollToId(href) {
  const el = document.querySelector(href);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
}

export function goToSection(navigate, pathname, href) {
  if (pathname === "/") {
    scrollToId(href);
    return;
  }
  navigate(`/${href}`);
  setTimeout(() => scrollToId(href), 120);
}
